// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"batch-entry-footer__container___fExyA","link":"batch-entry-footer__link___3vdGP"};
    if(module.hot) {
      // 1775523610557
      var cssReload = require("../../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  